function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M723.665,45.608a77.082,77.082,0,0,0-36.228,10.961,42.909,42.909,0,0,0-17.386,19.648,115.612,115.612,0,0,0-9.909,30.875s58.974,30.5,85.863,17.172c4.461-2.211,8.258-5.221,13.076-6.889,7.954-2.753,16.318-1.935,19.3,7.113,4.217,12.808,8.449,25.537,11.638,38.665a390.6,390.6,0,0,1,10.222,67.17q0.273,4.248.45,8.5c0.27,2.807.514,5.617,0.755,8.426q0.987,11.5,1.815,23.011,1.244,17.1,2.2,34.215,1.181,21.01,1.92,42.044,0.806,23.238.964,46.492c0.087,15.857-.09,31.717-0.664,47.565-0.548,15.109-1.446,30.213-2.965,45.257a360.73,360.73,0,0,1-5.937,39.574c-2.565,11.941-5.942,23.846-11.921,34.572-5.73,10.28-14.781,18.226-24.5,24.674-13.39,8.884-28.651,16.128-44.826,17.62-10.392.959-19.742-1.136-29.559-4.375-14.019-4.626-28.053-9.444-41.6-15.335a96.9,96.9,0,0,1-11.415-5.637c-1.661-1-4.575-2.5-5.1-4.591,0,0,3.842,66.883,8.587,71.176a81.144,81.144,0,0,0,15.174,12.722,56.668,56.668,0,0,0,8.786,4.608c1.383,0.571,7.222,3.4,8.326,2.092a2.929,2.929,0,0,0,.516-1.431c0.164-.958.255-5.021,0.956-5.577,0.845-.671,3.919,1.427,4.986,1.954,3.483,1.719,7.078,3.714,10.731,5.362a0.592,0.592,0,0,1,.444.657c0.1,2.158-.23,5.088.861,7.059,0.623,1.126,2.45,1.483,3.544,2.031a70.73,70.73,0,0,0,9.716,3.967,68.605,68.605,0,0,0,14.348,3.066A38.28,38.28,0,0,0,738.9,675.78c7.44-3.82,14.25-8.713,21.174-13.369,7.026-4.725,14.1-9.37,21.091-14.15,5.606-3.834,11.188-7.739,16.48-12,2.672-2.153,6.064-3.915,7.477-7.233a17.654,17.654,0,0,0,.97-5.041c1.666-14.986,2.791-30.006,4.027-45.033q2.592-31.272,4.56-62.592c1.391-22.563,2.507-45.15,2.989-67.751q0.137-6.375.194-12.751,0.162-18.88-.055-37.76-0.255-24.249-1.036-48.488-0.893-27.708-2.52-55.386c-1.162-19.508-2.629-39-4.508-58.452-1.863-19.283-4.123-38.532-7-57.69-2.675-17.811-5.867-35.562-10-53.1a325.631,325.631,0,0,0-13.5-44.674c-2.324-5.906-4.481-11.967-7.922-17.34-3.912-6.108-8.8-9.707-15.534-12.258A79.927,79.927,0,0,0,723.665,45.608Z",
  transform: "translate(-621.325 -44.769)",
  fill: "none",
  stroke: "#62b6ff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M660.142,107.092s-58.749,162.689-30.279,465.245",
  transform: "translate(-621.325 -44.769)",
  fill: "none",
  stroke: "#62b6ff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 102.415,
  cy: 16.857,
  rx: 32.791,
  ry: 11.766,
  fill: "none",
  stroke: "#62b6ff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 672.857,
  cy: 291.205,
  rx: 124.143,
  ry: 34.024,
  transform: "translate(-280.104 900.312) rotate(-86.509)",
  fill: "none",
  stroke: "#62b6ff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 40.934,
  cy: 317.389,
  rx: 12.88,
  ry: 17.134,
  fill: "none",
  stroke: "#62b6ff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

function SvgHeatbar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 197.356,
    height: 636.225,
    viewBox: "0 0 197.356 636.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heatbar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatbar);
export default __webpack_public_path__ + "static/media/heatbar.630b819ae4bb684017faf83deec3c024.svg";
export { ForwardRef as ReactComponent };